// Environment configuration for production
export const environment = {
  production: true,
  environmentName: 'prod',
  apiUrl: '',
  debugMode: false,
  enableLogs: false, // Disable console logs for production environment
  featureFlags: {
    enableAnalytics: true,
    enableExperimentalFeatures: false
  },
  services: {
    auth: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/auth/v1',
      auth0ClientId: 'Qi9MC2nkCgBAqCtLNZ8gN1tZjEbSAsBE',
      auth0Domain: 'login.hundredxinc.com',
      auth0AudienceDomain: 'hundredxinc.auth0.com',
      auth0CallbackURL: 'https://admin.hundredx.com/login',
      federatedSignout: false
    },
    firebaseToken: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/auth/v1/firebase/token'
    },
    account: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/account/v1'
    },
    contact: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/contact/v1'
    },
    feedback: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/feedback/v1'
    },
    participant: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/participant/v1'
    },
    transaction: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/transaction/v1'
    },
    solution: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/solution/v1',
      efgAccountId: 1017
    },
    cbreService: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/cbre/v1'
    },
    reporting: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/reporting/v1'
    },
    data: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/data/v1'
    },
    regionSync: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/region-sync'
    },
    masterData: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/master-data/v1'
    },
    plc: {
      baseUrl: 'https://api.hundredxinc.com',
      basePath: '/plc/v1'
    }
  }
};